import { alpha, styled} from "@mui/material/styles";
import { Tab, Tabs } from '@mzc-pdc/ui';

export const StyledToggleSwitchButton = styled(Tab)(({ theme, orientation }) => ({
    position: `relative`,
    zIndex: 1,
    maxWidth: `none`,
    minWidth: `0`,
    minHeight: `0`,
    width: 24,
    height: 24,
    padding: `0`,
    backgroundColor: `transparent`,
    borderRadius: `50%`,
    border: `none`,
    '&:hover': {
        backgroundColor: alpha(theme.palette.secondary[800], 0.08),
    },
    '&.Mui-selected': {
        borderBottomColor: `transparent`,
        color: theme.palette.common.black,
        backgroundColor: `transparent`,
    },


}));
export const StyledToggleSwitchButtonWrap = styled(Tabs)(({ theme, orientation }) => ({
    display:`inline-flex`,
    minHeight: `0`,
    padding: 4,
    borderRadius: 3,
    backgroundColor: theme.palette.greySecondary[50],
    '& .MuiTabs-indicator' : {
        width: `24px !important`,
        height: 24,
        bottom: 0,
        top: `0`,
        margin: 0,
        borderRadius: 2,
        boxShadow:` 0 2px 4px 0 rgba(0, 0, 0, 0.16)` ,
        backgroundColor:  theme.palette.common.white
    },

}));
